module.exports = __webpack_public_path__ + "img/logo_red.4e0aad25.svg";